import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter
} from '@angular/core';

import { Organization } from 'src/app/core/services/organizations/organization.model';
import { People } from 'src/app/core/services/people/people.model';
import { IDiscussion } from 'src/app/shared/models/discussion';
import { Group } from 'src/app/core/services/groups/group.model';
import { Event } from 'src/app/core/services/events/event.model';
import { Member } from 'src/app/core/services/organization/organization.model';
import { Clubs } from '../../../core/services/top/top.model';
import { IClub } from '../../../modules/clubs/model';

@Component({
  selector: 'app-search-results-list',
  templateUrl: './search-results-list.component.html',
  styleUrls: ['./search-results-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchResultsListComponent {
  @Input() totalAmount: number;
  @Input() isOrganizations: boolean;
  @Input() isPeople: boolean;
  @Input() isDiscussions: boolean;
  @Input() isGroups: boolean;
  @Input() isClubs: boolean;
  @Input() isEvents: boolean;
  @Input() isMembers: boolean;
  @Input() amountOfPages: number;
  @Input() currentPage: number;
  @Input() people: People[];
  @Input() organizations: Organization[];
  @Input() discussions: IDiscussion[];
  @Input() groups: { totalCount: number; items: Group[]; isLoading: boolean };
  @Input() events: Event[];
  @Input() members: Member[];
  @Input() clubs: IClub[];

  @Output() connect = new EventEmitter();
  @Output() unconnect = new EventEmitter();
  @Output() subscribe = new EventEmitter();
  @Output() unsubscribe = new EventEmitter();
  @Output() join = new EventEmitter();
  @Output() setPage = new EventEmitter();

  onProfileConnect($event) {
    this.connect.emit($event);
  }

  onProfileDisconnect($event) {
    this.unconnect.emit($event);
  }

  onOrganizationSubscribe($event) {
    this.subscribe.emit($event);
  }

  onOrganizationUnSubscribe($event) {
    this.unsubscribe.emit($event);
  }

  onGroupJoin($event) {
    this.join.emit($event);
  }

  onSetPage($event) {
    this.setPage.emit($event);
  }
}
